// extracted by mini-css-extract-plugin
export default {"cls1":"AiSummary-cls1_K3G","cls2":"AiSummary-cls2_sLr AiSummary-cls1_K3G"};